export enum AuthType {
  CONSUMER = 'CONSUMER',
  MANAGEMENT = 'MANAGEMENT',
}

export enum AuthEvent {
  PASSWORD_RESET = 'AUTH_PASSWORD_RESET',
  PASSWORD_RESET_MANAGEMENT = 'AUTH_PASSWORD_RESET_MANAGEMENT',
  MANAGEMENT_LOGIN_CODE = 'AUTH_MANAGEMENT_LOGIN_CODE',
  CONSUMER_VERIFICATION_CODE = 'AUTH_CONSUMER_VERIFICATION_CODE',
  CONSUMER_LOGIN_CODE = 'AUTH_CONSUMER_LOGIN_CODE',
}

export enum AuthLoginType {
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
}

export enum AuthPasswordLengths {
  MIN_LENGTH = 10,
  MAX_LENGTH = 512,
}

export enum AuthHeader {
  MANAGEMENT = 'x-access-management-token',
  CONSUMER = 'x-access-token',
  PROSPECT = 'x-prospect-token',
  API_KEY = 'api-key',
  PUBLIC = 'x-tl-api-key',
  PARTNER = 'api-key',
}

/**
 * @description At least 10 characters with a letter, a number, and a symbol.
 */
export const authPasswordRegex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{10,512}$/

export const AUTH_PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 10 characters and include a letter, a number, and a symbol.'

export const authPasswordRequirementChecks = [
  {
    id: 'length',
    regex: /.{10,512}/,
    text: 'At least 10 characters',
  },
  {
    id: 'letter',
    regex: /(?=.*[A-Za-z])/,
    text: 'At least 1 letter',
  },
  {
    id: 'number',
    regex: /(?=.*\d)/,
    text: 'At least 1 number',
  },
  {
    id: 'symbol',
    regex: /(?=.*[^A-Za-z\d])/,
    text: 'At least 1 symbol',
  },
] as const

export enum AuthErrorMessage {
  EMAIL_OR_PASSWORD_INVALID = 'Sorry, the email or password you entered is invalid.',
  ACCOUNT_ALREADY_EXISTS = 'Sorry, an account already exists for this email. Try logging in or resetting your password.',
  ACCOUNT_DOES_NOT_EXIST = 'Sorry, we could not find an account with that email.',
  FACEBOOK_LOGIN_INVALID = 'Sorry, an error occurred with Facebook Login, please try again.',
  GOOGLE_LOGIN_INVALID = 'Sorry, an error occurred with Google Login, please try again.',
  ACCOUNT_LINKING_REQUIRED = 'An account already exists for this email. Sign in using your existing method, then connect Google from account settings.',
  INVALID_PASSWORD = 'Sorry, your password must be at least 10 characters long and contain at least one uppercase letter, one lowercase letter, and one number.',
  INVALID_RESET_TOKEN = 'Sorry, your reset token is no longer valid.',
  INVALID_EMAIL_VERIFICATION_TOKEN = 'Sorry, your email verification token is no longer valid.',
  INVALID_LOGIN_CODE = 'Sorry, your sign-in code is no longer valid.',
  INVALID_API_KEY = 'You must provide a valid api-key.',
  API_KEY_AUTH_ERROR = 'You are not authenticated. You must provide a valid api-key.',
  UNAUTHENTICATED = 'You must be authenticated.',
  UNAUTHORIZED = 'You must be authorized.',
  EMAIL_VERIFICATION_REQUIRED = 'You must verify your email before continuing.',
  EXPIRED_API_KEY = 'The API key provided is no longer valid.',
}
